export const BUY_PRICE = 'buy';
export const MONTHLY_PRICE = 'monthly';
